"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _GooglePay;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  GOOGLE_PAY = _require2.GOOGLE_PAY,
  GOOGLE_PAY_CALLBACK_TRIGGERS = _require2.GOOGLE_PAY_CALLBACK_TRIGGERS;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('../../../commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
var GooglePay = /*#__PURE__*/_createClass(function GooglePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
  var _this = this;
  _classCallCheck(this, GooglePay);
  _defineProperty(this, "getShippingMethods", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(shippingAddress) {
      var requestBody;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              isExpressPdp: _this.isExpressPdp
            };
            if (shippingAddress) {
              requestBody.address = {
                city: shippingAddress.locality,
                country: shippingAddress.country,
                countryCode: shippingAddress.countryCode,
                stateCode: shippingAddress.administrativeArea,
                postalCode: shippingAddress.postalCode
              };
            }
            return _context.a(2, httpClient({
              method: 'POST',
              url: _this.shippingMethodsUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "selectShippingMethod", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
      var shipmentUUID, ID, requestBody;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            shipmentUUID = _ref2.shipmentUUID, ID = _ref2.ID;
            requestBody = {
              paymentMethodType: GOOGLE_PAY,
              shipmentUUID: shipmentUUID,
              methodID: ID,
              isExpressPdp: _this.isExpressPdp
            };
            return _context2.a(2, httpClient({
              method: 'POST',
              url: _this.selectShippingMethodUrl,
              data: {
                data: JSON.stringify(requestBody)
              }
            }));
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "paymentFromComponent", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, resolve, reject) {
      var response, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            $.spinner().start();
            _context3.n = 1;
            return httpClient({
              method: 'POST',
              url: _this.paymentFromComponentURL,
              data: {
                data: JSON.stringify(data),
                paymentMethod: GOOGLE_PAY
              }
            });
          case 1:
            response = _context3.v;
            helpers.createShowConfirmationForm(_this.showConfirmationAction);
            helpers.setOrderFormData(response);
            document.querySelector('#additionalDetailsHidden').value = JSON.stringify(_objectSpread(_objectSpread({}, data), response));
            GooglePay.handleGooglePayResponse(response, resolve, reject);
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t = _context3.v;
            $.spinner().stop();
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onShippingAddressChange", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(shippingAddress) {
      var _shippingMethodsData$;
      var shippingMethodsData, selectedShippingMethod, newCalculation;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return _this.getShippingMethods(shippingAddress);
          case 1:
            shippingMethodsData = _context4.v;
            if (!(shippingMethodsData !== null && shippingMethodsData !== void 0 && (_shippingMethodsData$ = shippingMethodsData.shippingMethods) !== null && _shippingMethodsData$ !== void 0 && _shippingMethodsData$.length)) {
              _context4.n = 3;
              break;
            }
            selectedShippingMethod = shippingMethodsData.shippingMethods[0];
            _context4.n = 2;
            return _this.selectShippingMethod(selectedShippingMethod);
          case 2:
            newCalculation = _context4.v;
            if (!(newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount)) {
              _context4.n = 3;
              break;
            }
            return _context4.a(2, {
              newShippingOptionParameters: GooglePay.getShippingOptionsParameters(selectedShippingMethod, shippingMethodsData),
              newTransactionInfo: GooglePay.getTransactionInfo(newCalculation, shippingMethodsData)
            });
          case 3:
            return _context4.a(2, {
              error: {
                reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                message: 'Cannot ship to the selected address',
                intent: 'SHIPPING_ADDRESS'
              }
            });
        }
      }, _callee4);
    }));
    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onShippingOptionChange", /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(shippingAddress, shippingOptionData) {
      var shippingMethodsData, shippingMethods, matchingShippingMethod, newCalculation;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return _this.getShippingMethods(shippingAddress);
          case 1:
            shippingMethodsData = _context5.v;
            shippingMethods = shippingMethodsData === null || shippingMethodsData === void 0 ? void 0 : shippingMethodsData.shippingMethods;
            matchingShippingMethod = shippingMethods.find(function (sm) {
              return sm.ID === shippingOptionData.id;
            });
            _context5.n = 2;
            return _this.selectShippingMethod(matchingShippingMethod);
          case 2:
            newCalculation = _context5.v;
            if (!(newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount)) {
              _context5.n = 3;
              break;
            }
            return _context5.a(2, {
              newTransactionInfo: GooglePay.getTransactionInfo(newCalculation, shippingMethodsData)
            });
          case 3:
            return _context5.a(2, {
              error: {
                reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                message: 'Cannot ship to the selected address',
                intent: 'SHIPPING_OPTION'
              }
            });
        }
      }, _callee5);
    }));
    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onAuthorized", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data, actions) {
      var authorizedEvent, resolve, reject, _authorizedEvent$paym, _authorizedEvent$paym2, customer, stateData, _t2;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            authorizedEvent = data.authorizedEvent;
            resolve = actions.resolve, reject = actions.reject;
            _context6.p = 1;
            customer = GooglePay.formatCustomerObject(authorizedEvent);
            stateData = {
              paymentMethod: {
                type: GOOGLE_PAY,
                googlePayToken: authorizedEvent === null || authorizedEvent === void 0 ? void 0 : (_authorizedEvent$paym = authorizedEvent.paymentMethodData) === null || _authorizedEvent$paym === void 0 ? void 0 : (_authorizedEvent$paym2 = _authorizedEvent$paym.tokenizationData) === null || _authorizedEvent$paym2 === void 0 ? void 0 : _authorizedEvent$paym2.token
              },
              paymentType: 'express'
            };
            _context6.n = 2;
            return _this.paymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
              customer: customer,
              isExpressPdp: _this.isExpressPdp
            }), resolve, reject);
          case 2:
            _context6.n = 4;
            break;
          case 3:
            _context6.p = 3;
            _t2 = _context6.v;
            reject(_t2);
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref7.apply(this, arguments);
    };
  }());
  _defineProperty(this, "onPaymentDataChanged", /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(intermediatePaymentData) {
      var callbackTrigger, shippingAddress, shippingOptionData, paymentDataRequestUpdate;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            callbackTrigger = intermediatePaymentData.callbackTrigger, shippingAddress = intermediatePaymentData.shippingAddress, shippingOptionData = intermediatePaymentData.shippingOptionData;
            paymentDataRequestUpdate = {};
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.INITIALIZE)) {
              _context7.n = 3;
              break;
            }
            if (!_this.isExpressPdp) {
              _context7.n = 1;
              break;
            }
            _context7.n = 1;
            return createTemporaryBasket();
          case 1:
            _context7.n = 2;
            return _this.onShippingAddressChange(shippingAddress);
          case 2:
            paymentDataRequestUpdate = _context7.v;
          case 3:
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_ADDRESS)) {
              _context7.n = 5;
              break;
            }
            _context7.n = 4;
            return _this.onShippingAddressChange(shippingAddress);
          case 4:
            paymentDataRequestUpdate = _context7.v;
          case 5:
            if (!(callbackTrigger === GOOGLE_PAY_CALLBACK_TRIGGERS.SHIPPING_OPTION)) {
              _context7.n = 7;
              break;
            }
            _context7.n = 6;
            return _this.onShippingOptionChange(shippingAddress, shippingOptionData);
          case 6:
            paymentDataRequestUpdate = _context7.v;
          case 7:
            return _context7.a(2, new Promise(function (resolve) {
              resolve(paymentDataRequestUpdate);
            }));
        }
      }, _callee7);
    }));
    return function (_x1) {
      return _ref8.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getConfig", function () {
    return {
      showPayButton: _this.showPayButton,
      isExpress: _this.isExpress,
      buttonType: 'buy',
      emailRequired: true,
      shippingAddressRequired: true,
      shippingOptionRequired: true,
      shippingAddressParameters: {
        allowedCountryCodes: ['US'],
        phoneNumberRequired: true
      },
      billingAddressRequired: true,
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true
      },
      gatewayMerchantId: window.merchantAccount,
      configuration: _this.config,
      callbackIntents: ['SHIPPING_ADDRESS', 'SHIPPING_OPTION'],
      amount: _this.amount,
      onAuthorized: _this.onAuthorized,
      onSubmit: function onSubmit() {},
      paymentDataCallbacks: {
        onPaymentDataChanged: _this.onPaymentDataChanged
      }
    };
  });
  _defineProperty(this, "getComponent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
    var checkout, googlePayConfig;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          _context8.n = 1;
          return initializeCheckout(_this.applicationInfo, _this.translations);
        case 1:
          checkout = _context8.v;
          googlePayConfig = _this.getConfig();
          return _context8.a(2, window.AdyenWeb.createComponent(GOOGLE_PAY, checkout, googlePayConfig));
      }
    }, _callee8);
  })));
  var _window = window,
    basketAmount = _window.basketAmount,
    showConfirmationAction = _window.showConfirmationAction,
    shippingMethodsUrl = _window.shippingMethodsUrl,
    selectShippingMethodUrl = _window.selectShippingMethodUrl,
    paymentFromComponentURL = _window.paymentFromComponentURL;
  this.store = store;
  this.helpers = helpers;
  this.amount = initialAmount || JSON.parse(basketAmount);
  this.showPayButton = true;
  this.isExpress = true;
  this.isExpressPdp = isExpressPdp;
  this.paymentFromComponentURL = paymentFromComponentURL;
  this.showConfirmationAction = showConfirmationAction;
  this.shippingMethodsUrl = shippingMethodsUrl;
  this.selectShippingMethodUrl = selectShippingMethodUrl;
  this.applicationInfo = applicationInfo;
  this.translations = adyenTranslations;
  this.config = config;
});
_GooglePay = GooglePay;
_defineProperty(GooglePay, "formatCustomerObject", function (customerData) {
  var shippingData = customerData.shippingAddress;
  var billingData = customerData.paymentMethodData.info.billingAddress;
  var nameParts = customerData.shippingAddress.name.split(' ');
  var firstName = nameParts[0];
  var lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : ''; // Join the rest
  return {
    addressBook: {
      addresses: {},
      preferredAddress: {
        address1: shippingData.address1,
        address2: shippingData.address2 ? shippingData.address2 : null,
        city: shippingData.locality,
        countryCode: {
          displayValue: shippingData.countryCode,
          value: shippingData.countryCode
        },
        firstName: firstName,
        lastName: lastName,
        ID: customerData.email,
        postalCode: shippingData.postalCode,
        stateCode: shippingData.administrativeArea
      }
    },
    billingAddressDetails: {
      address1: billingData.address1,
      address2: billingData.address2 ? billingData.address2 : null,
      city: billingData.locality,
      countryCode: {
        displayValue: billingData.countryCode,
        value: billingData.countryCode
      },
      firstName: firstName,
      lastName: lastName,
      postalCode: billingData.postalCode,
      stateCode: billingData.administrativeArea
    },
    customer: {},
    profile: {
      firstName: firstName,
      lastName: lastName,
      email: customerData.email,
      phone: shippingData.phoneNumber
    }
  };
});
_defineProperty(GooglePay, "getTransactionInfo", function (newCalculation) {
  var _newCalculation$local, _newCalculation$grand, _newCalculation$grand2;
  return {
    countryCode: newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$local = newCalculation.locale) === null || _newCalculation$local === void 0 ? void 0 : _newCalculation$local.slice(-2),
    currencyCode: newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand = newCalculation.grandTotalAmount) === null || _newCalculation$grand === void 0 ? void 0 : _newCalculation$grand.currency,
    totalPriceStatus: 'FINAL',
    totalPriceLabel: 'Total',
    totalPrice: "".concat(newCalculation === null || newCalculation === void 0 ? void 0 : (_newCalculation$grand2 = newCalculation.grandTotalAmount) === null || _newCalculation$grand2 === void 0 ? void 0 : _newCalculation$grand2.value)
  };
});
_defineProperty(GooglePay, "getShippingOptionsParameters", function (selectedShippingMethod, shippingMethodsData) {
  return {
    defaultSelectedOptionId: selectedShippingMethod.ID,
    shippingOptions: shippingMethodsData.shippingMethods.map(function (sm) {
      return {
        label: sm.displayName,
        description: sm.description,
        id: sm.ID
      };
    })
  };
});
_defineProperty(GooglePay, "handleAuthorised", function (response, resolve) {
  var _document$querySelect, _$;
  resolve();
  if (document.querySelector('#result')) {
    var _response$fullRespons, _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5, _response$fullRespons6, _response$fullRespons7;
    document.querySelector('#result').value = JSON.stringify({
      pspReference: (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.pspReference,
      resultCode: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.resultCode,
      paymentMethod: (_response$fullRespons3 = response.fullResponse) !== null && _response$fullRespons3 !== void 0 && _response$fullRespons3.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons4 = response.fullResponse) === null || _response$fullRespons4 === void 0 ? void 0 : (_response$fullRespons5 = _response$fullRespons4.additionalData) === null || _response$fullRespons5 === void 0 ? void 0 : _response$fullRespons5.paymentMethod,
      donationToken: (_response$fullRespons6 = response.fullResponse) === null || _response$fullRespons6 === void 0 ? void 0 : _response$fullRespons6.donationToken,
      amount: (_response$fullRespons7 = response.fullResponse) === null || _response$fullRespons7 === void 0 ? void 0 : _response$fullRespons7.amount
    });
  }
  (_document$querySelect = document.querySelector('#showConfirmationForm')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.submit();
  if ((_$ = $) !== null && _$ !== void 0 && _$.spinner) {
    var _$$spinner;
    (_$$spinner = $.spinner()) === null || _$$spinner === void 0 ? void 0 : _$$spinner.stop();
  }
});
_defineProperty(GooglePay, "handleError", function (reject) {
  var _document$querySelect2, _$2;
  reject();
  if (document.querySelector('#result')) {
    document.querySelector('#result').value = JSON.stringify({
      error: true
    });
  }
  (_document$querySelect2 = document.querySelector('#showConfirmationForm')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.submit();
  if ((_$2 = $) !== null && _$2 !== void 0 && _$2.spinner) {
    var spinnerFn = $.spinner();
    if (spinnerFn.stop) {
      var _$$spinner2;
      (_$$spinner2 = $.spinner()) === null || _$$spinner2 === void 0 ? void 0 : _$$spinner2.stop();
    }
  }
});
_defineProperty(GooglePay, "handleGooglePayResponse", function (response, resolve, reject) {
  if (response.resultCode === 'Authorised') {
    _GooglePay.handleAuthorised(response, resolve);
  } else {
    _GooglePay.handleError(reject);
  }
});
module.exports = GooglePay;